import React from "react";
import { Button, Container } from "Components/ReactstrapSlim";
import { useContextUsModal } from "../../../hooks";

import classes from "./ContactSection.module.scss";

const ContactSection: React.FC = () => {
   const { open } = useContextUsModal()
   return (
      <section id="contact" className={classes.section}>
         <Container>
            <div className={classes.container}>
               <div className={classes.title}>
                  Still want to know <br />
                  more?
               </div>
               <div className={classes.actions}>
                  <Button color="primary-on-ocean" onClick={() => open()} >
                     Contact us
                  </Button>
               </div>
            </div>
         </Container>
      </section>
   );
};

export default ContactSection;
